import React from 'react';
import { useDispatch } from 'react-redux';

import { CasinoGameIcon, CasinoPlaySelector } from '@swf/casino';
import Body from '@swf/components/StarsModal/components/Body';
import CloseButton, { Variant } from '@swf/components/StarsModal/components/CloseButton';
import Header from '@swf/components/StarsModal/components/Header/Header';
import useSearchParams from '@swf/core/hooks/useSearchParams';
import type { Dispatch } from '@swf/core/store';
import type { CasinoGame, PlayType } from '@swf/core/types/CasinoGame';

import styles from './CasinoPlayerSelector.scss';

interface CasinoPlayerSelectorParams {
  game: CasinoGame;
  raceId?: string;
  widgetId?: string;
}

const CasinoPlayerSelector: React.FC = () => {
  const { game, raceId, widgetId } = useSearchParams<CasinoPlayerSelectorParams>();

  const {
    modal: { close },
    casino: { launch }
  } = useDispatch<Dispatch>();

  const handleClick = (playType: PlayType) => {
    launch({ game, playType, raceId, widgetId });
    close();
  };

  return (
    <section className={styles.section}>
      <Header className={styles.header}>
        <div>
          <div className={styles.gameImage}>
            <CasinoGameIcon className={styles.image} game={game} />
          </div>
        </div>
        <span className={styles.title}>{game.name}</span>
        <CloseButton variant={Variant.Light} />
      </Header>
      <Body className={styles.container}>
        <div className={styles.buttons}>
          <CasinoPlaySelector multiplayer onClick={handleClick} />
        </div>
      </Body>
    </section>
  );
};

export default CasinoPlayerSelector;
